import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { SkeletonLoaderComponent } from '@app/shared/modules/subscriber/skeleton/skeleton-loader/skeleton-loader.component';

@Directive({ selector: '[appSkeleton]' })
export class SkeletonDirective implements OnChanges {
  @Input('appSkeleton') isLoading = false;
  @Input('appSkeletonCircle') circle = false;
  @Input('appSkeletonWidth') width: string | undefined;
  @Input('appSkeletonHeight') height: string | undefined;
  @Input('appSkeletonClassName') className: string | undefined;
  @Input('appSkeletonBackground') background: string | undefined;
  @Input('appSkeletonTimesRepeat') timesRepeat = 1;

  constructor(private readonly tpl: TemplateRef<any>, private readonly vcr: ViewContainerRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLoading']) {
      this.vcr.clear();

      if (changes['isLoading'].currentValue) {
        Array.from({ length: this.timesRepeat }).forEach(() => {
          const ref = this.vcr.createComponent(SkeletonLoaderComponent);

          Object.assign(ref.instance, {
            width: this.width,
            height: this.height,
            className: this.className,
            circle: this.circle,
            background: this.background,
          });
        });
      } else {
        this.vcr.createEmbeddedView(this.tpl);
      }
    }
  }
}
